import React, { useEffect, createContext, useState } from 'react';
import AuthService from '../api/services/AuthService';
import LoaderHelper from '../customComponent/Loading/LoaderHelper';
import { alertErrorMessage } from '../customComponent/CustomAlertMessage';
export const ProfileContext = createContext();

export function ProfileProvider(props) {
  const [userDetails, setUserDetails] = useState([]);
  const [loginDetails, setLoginDetails] = useState([]);
  const [newStoredTheme, setNewStoredTheme] = useState('');
  const [lastLogin, setLastLogin] = useState("");
  const [currentPage, setCurrentPage] = useState("Dashboard");
  const [themeUpdated, setThemeUpdated] = useState(true);

  const [activeTab, setActiveTab] = useState("");
  const token = sessionStorage.getItem('token');


  const handleUserDetails = async () => {
    LoaderHelper.loaderStatus(true);
    await AuthService.getDetails().then(async (result) => {
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        try {
          setUserDetails(result?.data);
        } catch (error) {
          alertErrorMessage(error);
        }
      } else {
        LoaderHelper.loaderStatus(false);
        alertErrorMessage(result?.message);
      }
    });
  };

  const isAdmin = () => {
    return userDetails.admin_type === 1;
  };

  const isUser = () => {
    return userDetails.admin_type === 2;
  };
  const userType_ = userDetails?.admin_type || null;

  const userPermissions = userDetails?.permissions || [];


  const activityLogs = async (skip) => {
    LoaderHelper.loaderStatus(true)
    await AuthService.getActivityLogs(0, 1).then(async result => {
      LoaderHelper.loaderStatus(false)
      if (result?.success) {
        setLastLogin(result?.data[0]?.createdAt)
      }
    });
  };


  useEffect(() => {
    if (token) {
      handleUserDetails();
    //   activityLogs();
    }
  }, [token]);




  const handleTheme = () => {
    const htmlTag = document.documentElement;
    const currentTheme = htmlTag.getAttribute('data-theme');
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    sessionStorage.setItem('theme', newTheme);
    htmlTag.setAttribute('data-theme', newTheme);
    setNewStoredTheme(newTheme);
  };

  React.useEffect(() => {
    const storedTheme = sessionStorage.getItem('theme');
    const htmlTag = document.documentElement;
    if (storedTheme) {
      htmlTag.setAttribute('data-theme', storedTheme);
    } else {
      const defaultTheme = 'dark';
      htmlTag.setAttribute('data-theme', defaultTheme);
      sessionStorage.setItem('CurrentTheme', defaultTheme);
    }
  }, []);


  return (
    <>

      <ProfileContext.Provider value={{ currentPage, setCurrentPage, lastLogin, userDetails, setUserDetails, handleUserDetails, setLoginDetails, loginDetails, handleTheme, newStoredTheme, activeTab, setActiveTab, themeUpdated, setThemeUpdated, isAdmin, isUser, userPermissions, userType_ }}>
        {props.children}
      </ProfileContext.Provider>
    </>
  );
}
